
import {finalize} from 'rxjs/operators';
// angular
import { Component, Inject, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { PatientsService } from '../../patients/patients.service';
import { BaseService } from '../../shared/base.service';
import { IMyDpOptions, IMyInputFieldChanged, IMyInputFocusBlur } from 'mydatepicker';
import * as moment from 'moment';
import { AppService } from '../../app.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import { saveAs } from 'file-saver';
import { QuestionnairesService } from '../questionnaires/questionnaires.service';
import { SecureApi } from '../../core/secure.api';
import { DialogComponent } from '../../dialog/dialog.component';
import { BaseComponent } from '../../shared/base.component';
import { PatientComponent } from '../patient.component';
import { PatientService } from '../patient.service';
import { PatientQuestionnairesComponent } from '../patient-questionnaires/patient-questionnaires.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: 'create-se-modal.component.html',
    styleUrls: ['create-se-modal.component.scss']
})

export class CreateSEModalComponent extends PatientQuestionnairesComponent implements OnInit, AfterViewInit {

    type: string;
    url = 'patients';
    errorMessage = [];
    successMessage = '';
    formSubmitted = false;
    params: any = {};
    queryParams = {};
    form: FormGroup;
    doctors: Object[];
    assistants: Object[];
    mpa: Object[];
    creationDate: string;
    date: Date;
    age: number;
    languages: Object[];
    questionnaires: any;
    SETypes = [
        {
            'title' : 'Send Reminder',
            'name'  : 'reminder',
            'label' : 'Email',
            'type'  : 'reminder',
            'action' : 'Send',
            'route': '',
            'disabled' : false
        },{
            'title' : 'By email',
            'createTitle': 'Start Self-Evaluation',
            'name': 'email',
            'label' : 'By email',
            'type'  : 'se_di',
            'action': 'Send by e-mail',
            'route': '',
            'disabled' : false
        },
        {
            'title': 'Self Evaluation',
            'createTitle': 'Start Self-Evaluation',
            'name'  : 'direct',
            'label': 'Open directly',
            'type': 'local_se_di',
            'action': 'Open directly',
            'route': '',
            'disabled' : false
        },{
            'title': 'Self Evaluation',
            'createTitle': 'Start Self-Evaluation',
            'name': 'pdf',
            'label': 'By letter',
            'type': 'pdf_se_di',
            'action': 'Create letter',
            'route': '',
            'disabled' : false
        }
    ];
    activeSEType = this.SETypes[1];
    activeQuestionnaireId = null;
    // patientId: number;
    userRoleId: number;
    dateFormat: string = 'DD.MM.YYYY';

    validateCssBirthday: string = 'form-unfocused';
    validateCssEntryDate: string = 'form-unfocused';
    isValidBirthday: boolean = true;
    isValidEntryDate: boolean = true;

    emailModel: string;

    // @ViewChild('revocationPop', { static: false }) revocationPop: PopoverDirective;
    @ViewChild('modal', { static: false }) public modal: ModalDirective;
    @ViewChild('modalArchive',  {static: true}) public modalArchive: ModalDirective;
    @ViewChild('dialog', { static: true }) dialog: DialogComponent;
    @Input() patientId: number;

    formLoading: boolean;
    patient: any;
    latestId: any;
    isCollapsed : boolean = true;
    questionnaireEmailTemplates: Object[] = [];
    repeatedQuestionnaireEmailTemplates: Object[] = [];
    selectedTemplateTranslationId: number = 0;
    regexForQuestionnaireTag = /<a\s+(?:[^>]*?\s+)?title=['"]?questionnaire-link["'](.*?)\1/;
    isValidDueDate: boolean = true;
    _noActiveQuestionnaire = false;

    // Reminder
    isSendReminder = false;
    activeSendReminder = false;
    emailReminderTemplates: Object[] = [];
    selectedTemplateReminderId: number = 0;
    emptyQuestionnaireText: string = 'This patient has no questionnaire yet.';
    showRepeated = false;
    modalClassName = 'patient-selfevaluation-modal';
    isRegisteredPatient = false;
    customIds = [];
    srCustomId = null;

    constructor(public fb: FormBuilder,
        public secureApi: SecureApi,
        public authService: AuthService,
        public route: ActivatedRoute,
        public baseService: BaseService,
        public questionnairesService: QuestionnairesService,
        public patientsService: PatientsService,
        public appService: AppService,
        public router: Router,
        public patientService: PatientService,
        public translate: TranslateService,
        @Inject(PatientComponent) public parent: PatientComponent,
    ) {
        super(appService, authService, baseService, questionnairesService, patientService,fb, patientsService, route, translate, router);
    }

    ngOnInit() {
        this.formLoading = true;

        this.type = this.route.snapshot.data.type;

        this.route.params.subscribe(params => {
            this.params = this.route.parent.snapshot.params;
            this.patientId = this.params['id'] ? this.params['id'] : params['patientId'];
            this.appService.isLoading = true;
        });

        this.route.queryParams.subscribe(queryParams => {
            this.queryParams = queryParams;
            this.activeQuestionnaireId = queryParams['archive'];
            this.isSendReminder = queryParams['reminder'];
            this.activeSendReminder = queryParams['activeSendReminder'];
        });
    }

    ngAfterViewInit() {
        this.modal.config.backdrop = false;
        this.modal.config.ignoreBackdropClick = true;
        this.modal.config.keyboard = false;

        this.modalArchive.config.backdrop = false;
        this.modalArchive.config.ignoreBackdropClick = true;
        this.modalArchive.config.keyboard = false;

        const showArchiveMessage = this.authService.isShowNotice(this.authService.NOTICE_TYPE.ARCHIVE) || false;
        if (this.activeQuestionnaireId) {
            this.appService.isLoading = false;
            if(showArchiveMessage){
                return this.showArchiveModal();
            }
            return this.archiveQuestionnaires();
        }
        if (this.isSendReminder) {
            return this.handleSendReminder();
        }
        return this.openQuestionnaireModal();
    }

    buildForm(type): void {
        this.form = this.fb.group({
            id: [{ value: null }],
            patient_id: [{ value: null }],
            questionnaire_type_id: [{ value: null }],
            token: [{ value: null }],
            answer_method: [{ value: null }],
            due_date: [{ value: null }],
            email: [''],
            template_translation_id: [{ value: null }],
            is_study: [''],

            type: [{ value: null }],
            content: ['', [<any>Validators.required, <any>Validators.pattern(this.regexForQuestionnaireTag)]],
            email_subject: [{ value: '' }],
            email_header: [{ value: '' }],
            add_disclaimer: [{ value: false }],
            disclaimer_text: [{ value: '' }],
            is_repeated : [''],
            custom_id : [null]
        });
        if(type === 'reminder' || type === 'se_di') {
            this.form.controls['email'].setValidators([<any>Validators.required,
                <any>Validators.pattern('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')]);
            const email = (this.patient && this.patient.email) ? this.patient.email : null;
            this.form.controls['email'].setValue(email);
        }
        this.initDueDateCalendarSettings();
    }

    createFormModal() {
        if (this.type === 'read') {
            for (const column in this.form.controls) {
                this.form.controls[column].disable();
            }
        }

        this.patientsService.read(this.params['id']).pipe(
            finalize(() => {
                this.appService.isLoading = false;
                this.formLoading = false;
            }))
            .subscribe(
                response => {
                    this.patient = response['patient'];
                    this.patientId = this.patient.id;
                    this.SETypes.forEach( SEType => {
                       if(SEType.type === 'pdf_se_di') {
                           SEType.disabled = (this.patient.clinic && this.patient.clinic.show_se_pdf) ? this.patient.clinic.show_se_pdf : 0;
                       }
                       if(SEType.type === 'se_di') {
                           SEType.disabled = this.isSendReminder;
                       }
                    });
                    this.languages = response['languages'];
                    this.creationDate = response['patient'].creation_date;

                    if (this.patient.language_id) {
                        this.form.controls['language_id'].setValue(this.patient.language_id);
                    } else {
                        this.form.controls['language_id'].setValue(response['default_language']);
                    }
                }
            );
    }

    showModal() {
        this.formLoading = false;
        this.appService.isLoading = false;
        this.SETypes.forEach(SEType => {
            switch (SEType.type) {
                case 'pdf_se_di':
                    SEType.disabled = (this.patient.clinic && (!this.patient.clinic.show_se_pdf || this.patient.clinic.show_se_pdf === 0)) ? true : false;
                    break;
                case 'se_di':
                    SEType.disabled = this.isSendReminder;
                    break;
                case 'reminder':
                    SEType.disabled = !this.isSendReminder;
                    break;
                default:
                    return;
            }
        });
        this.modal.show();
    }

    hideModal() {
        this.modal.hide();
        if (this.params && this.params['id']) {
            return this.router.navigate(['patient/' + this.patientId]);
        }
        return this.router.navigate(['patients']);
    }

    // hide modal when clicking Cancel
    hideArchiveModal(isUpdated?: boolean) {
        this.modalArchive.hide();

        // unsubscribe subscription to avoid memory leaks & prevent this.modal.onHidden() being called repeatedly
        if (typeof this.modalHidingSub !== 'undefined') {
            this.modalHidingSub.unsubscribe();
        }
        if(isUpdated){
            return this.openQuestionnaireModal();
        }
        if (this.params && this.params['id']) {
            return this.router.navigate(['patient/' + this.patientId]);
        }
        return this.router.navigate(['patients']);
    }

    /**
     * @param {boolean} isUpdate
     */
    goBack(isUpdate = false) {
        if (this.params['redirectUrl']) {
            return this.router.navigate([this.params['redirectUrl']]);
        }
        if (isUpdate && this.type === 'createSEPatientProfile') {
            this.parent.loadData();
        }

        return this.hideModal();
    }

    /**
     * @param patientModel
     * @param {boolean} isValid
     */
    submit(patientModel: any, isValid: boolean) {

        if (!isValid && this.type !== 'read') {
            this.formSubmitted = true;
            return;
        }

        this.resetErrors();

        const type = 'se_di';
        switch (this.activeSEType.type) {
            case 'local_se_di':
                return this.openLocalInterview(type);

            case 'pdf_se_di':
                return this.openLocalInterview(type);

            case 'se_di':
                return this.openEmailInterview(type);

            case 'reminder':
                return this.sendReminder(patientModel, isValid);

            default:
                return false;
        }
    }

    resetErrors() {
        if (this.errorMessage.length > 0) {
            this.errorMessage = [];
        }
    }

    get isDoctorCreating() {
        return this.authService.isDoctor;
    }

    /**
     * Open Add/Send questionnaire form
     * @param {Object} params
     */
    openQuestionnaireModal() {
        /**
         * Define form open questionnaire
         * @type {FormGroup}
         */
        this.buildForm(this.activeSEType.type);
        /**
         * Get user info and set default value
         */
        if (!this.patientId) {
            return this.hideModal();
        }
        this.questionnairesService.read(this.patientId, this.activeSEType.type)
            .subscribe(
                response => {
                    this.questionnaires = response['questionnaires'];
                    this.customIds = response['custom_ids'];

                    this.patient = response['patient'];
                    this.patientId = this.patient.id;
                    this.languages = response['languages'];
                    this.creationDate = response['patient'].creation_date;
                    /**
                     * Parse email template by language
                     */
                    const languageId = (this.patient && this.patient.language_id) ? this.patient.language_id : 1;
                    let filteredByLanguages = [];
                    if (response['emailTemplates']) {
                        filteredByLanguages = this.getTemplateTranslation(response['emailTemplates'], languageId);
                        this.form.controls['content'].setValue(filteredByLanguages[0][0]['content']);
                        this.form.controls['email_subject'].setValue(filteredByLanguages[0][0]['email_subject']);
                        this.form.controls['email_header'].setValue(filteredByLanguages[0][0]['email_header']);
                        this.form.controls['add_disclaimer'].setValue(filteredByLanguages[0][0]['add_disclaimer']);
                        this.form.controls['disclaimer_text'].setValue(filteredByLanguages[0][0]['disclaimer_text']);
                    }

                    this.questionnaireEmailTemplates = [].concat.apply([], filteredByLanguages);

                    if (response['repeatedTemplates']) {
                        this.repeatedQuestionnaireEmailTemplates = [].concat.apply([], this.getTemplateTranslation( response['repeatedTemplates'], languageId));
                    }

                    if (this.userRoleId === 4) {
                        this.questionnaires = this.questionnaires.filter(element => element['type'] !== 'di');
                    }
                    this.form.controls['questionnaire_type_id'].setValue(this.activeSEType.type);
                    this.form.controls['email'].setValue(this.patient['email']);
                    this.form.controls['template_translation_id'].setValue(this.questionnaireEmailTemplates[0]['id']);

                    this.isCollapsed = this.patient.email ? true : false;
                    this.showRepeated =  response['show_repeated'];
                    this.form.controls['is_repeated'].setValue(response['show_repeated']);
                    if (this.showRepeated) {
                        let selectedTemplate = this.repeatedQuestionnaireEmailTemplates[0];
                        this.form.controls['content'].markAsPristine();
                        this.form.controls['content'].setValue(selectedTemplate['content']);
                        this.form.controls['email_subject'].setValue(selectedTemplate['email_subject']);
                        this.form.controls['email_header'].setValue(selectedTemplate['email_header']);
                        this.form.controls['add_disclaimer'].setValue(selectedTemplate['add_disclaimer']);
                        this.form.controls['disclaimer_text'].setValue(selectedTemplate['disclaimer_text']);
                        this.form.controls['template_translation_id'].setValue(selectedTemplate['id']);
                    }
                    this.showModal();

                    //set custom sr value
                    this.customIds.forEach(custom => {
                        if (custom.is_default) {
                            this.form.controls['custom_id'].setValue(custom.id);
                        }
                    });
                },
                error => {
                    this.errorMessage = this.appService.parseErrors(error);
                    this.modal.hide();
                    this.openAlertModal({icon: 'fas fa-exclamation-triangle', warning: true}, this.errorMessage);
                }
            );
    }

    getTemplateTranslation(templates, languageId) {
        return templates.map(template => template.translations.filter(function (translation) {
            return translation.language_id === languageId;
        }));
    }

    onSelectEmailTemplate2(value) {
        let selectedTemplate = this.questionnaireEmailTemplates.find((template) => {
            return template['id'] == value;
        });

        this.form.controls['content'].markAsPristine();
        this.form.controls['content'].setValue(selectedTemplate['content']);
        this.form.controls['email_subject'].setValue(selectedTemplate['email_subject']);
        this.form.controls['email_header'].setValue(selectedTemplate['email_header']);
        this.form.controls['add_disclaimer'].setValue(selectedTemplate['add_disclaimer']);
        this.form.controls['disclaimer_text'].setValue(selectedTemplate['disclaimer_text']);
    }

    onDueDateInputChanged(event: IMyInputFieldChanged) {
        this.isValidDueDate = event.valid;
    }

    openAlertModal(params: Object, errorMessage: any) {
        const dialog = this.dialog.openAlert(params);
        dialog.showAlert(errorMessage[0]);
    }

    openLocalInterview(type: string) {

        window.onbeforeunload = function() {};

        if (this.form.controls['is_study'].value) {
            type += '_study';
        }

        const model = {
            id: null,
            patient_id: this.patientId,
            questionnaire_type_id: type,
            token: null,
            answer_method: 'local',
            email: this.form.controls['email'].value,
            template_translation_id: this.form.controls['template_translation_id'].value,
            is_pdf: this.activeSEType.type === 'pdf_se_di' ? 1 : 0,
            content: '',
            is_repeated: this.form.controls['is_repeated'].value ? 1 : 0,
            custom_id : this.form.controls['custom_id'].value
         };

        this.appService.isLoading = true;

        if (this.activeSEType.type === 'pdf_se_di') {
            this.secureApi.downloadFile('patient/save-questionnaire/update/' + this.patientId, model).pipe(
                finalize(() => this.appService.isLoading = false))
                .subscribe(response => {
                        // Get filename
                        const filename = response['headers'].get('File-Name');
                        saveAs(response['body'], filename);
                        setTimeout(() => {
                            this.goBack(true);
                        }, 1000);
                    },
                    error => {
                        this.errorMessage = this.appService.parseErrors(error);
                    });
        } else {
            this.baseService.submit('patient/save-questionnaire', this.patientId, model).pipe(
                finalize(() => this.appService.isLoading = false))
                .subscribe(response => {
                        // Log off and redirect to questionnaire link if On Local Device selected
                        if (response['token'] !== '' && this.activeSEType.type === 'local_se_di' && response['local_questionnaire_link']) {
                            localStorage.setItem('openSE', JSON.stringify(true));
                            const link = response['local_questionnaire_link'];
                            window.location.href = link;
                        } else {
                            this.goBack();
                        }
                    },
                    error => {
                        this.errorMessage = this.appService.parseErrors(error);
                    }
                );
        }
    }

    openEmailInterview(type: string) {
        if (this.form.controls['is_study'].value) {
            type += '_study';
        }

        let formattedDueDate = moment({
            year: this.form.controls['due_date'].value.date.year,
            month: this.form.controls['due_date'].value.date.month - 1, // http://momentjs.com/docs/#/get-set/month/
            day: this.form.controls['due_date'].value.date.day,
        });



        const model = {
            id: null,
            patient_id: this.patientId,
            questionnaire_type_id: type,
            token: null,
            answer_method: 'email',
            email: this.form.controls['email'].value,
            template_translation_id: this.form.controls['template_translation_id'].value,
            is_pdf: 0,
            content: this.form.controls['content'].value,
            email_subject: this.form.controls['email_subject'].value,
            email_header: this.form.controls['email_header'].value,
            add_disclaimer: this.form.controls['add_disclaimer'].value,
            disclaimer_text: this.form.controls['disclaimer_text'].value,
            due_date: formattedDueDate.format(this.dateFormat),
            is_repeated: this.form.controls['is_repeated'].value ? 1 : 0,
            custom_id : this.form.controls['custom_id'].value
        };

        this.appService.isLoading = true;
        this.baseService.submit('patient/send-questionnaire', this.patientId, model).pipe(
            finalize(() => this.appService.isLoading = false))
            .subscribe(response => {

                    setTimeout(() => {
                        this.goBack(true);
                    }, 1000);
                },
                error => {
                    this.errorMessage = this.appService.parseErrors(error);
                }
        );
    }
    changeSEType(SEType) {
        if(SEType.disabled) {
            return false;
        }
        this.activeSEType = SEType;

        if(SEType.type === 'reminder' || SEType.type === 'se_di') {
            this.form.controls['email'].setValidators([<any>Validators.required,
                <any>Validators.pattern('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')]);
            const email = (this.patient && this.patient.email) ? this.patient.email : null;
            this.form.controls['email'].setValue(email);
        } else {
            this.form.get('email').clearValidators();
            this.form.get('email').updateValueAndValidity();
        }
    }

    // display modal
    showArchiveModal() {
        this.formLoading = false;
        this.modalArchive.show();
    }

    archiveQuestionnaires() {
        if (!this.activeQuestionnaireId) {
            return false;
        }
        this.isLoading = true;
        const showInFuture = this.showArchiveMessageFuture ? 1 : 0;
        this.questionnairesService.archiveQuestionnaires(this.activeQuestionnaireId, showInFuture).pipe(
            finalize(() => this.isLoading = false))
            .subscribe(
                response => {
                    const message = response['message'];
                    this.isUpdated = true;
                    this.authService.setData('show_confirm_archive_self_report_modal', showInFuture);

                    this.activeQuestionnaireId = null;
                    this.isSendReminder = false;
                    this.activeSEType = this.SETypes[1];
                    this.hideArchiveModal(true);
                    // disable the selected diagnosis additions/removals
                    // this.patientService.questionnaireIsArchived = true;

                    if (message !== 'undefined' && message !== '') {
                        this.responseMessage = message;
                    }
                },
                error => {
                    this.isLoading = false;
                    this.errorMessage = this.appService.parseErrors(error);
                }
            );
    }

    /**
     * Load data for send reminder window
     * @param {Object} params
     */
    handleSendReminder(params ?: Object) {
        this.patientsService.read(this.patientId).subscribe(response => {
                this.patient = response['patient'];
                this.questionnaires = response['questionnaires'];
                this.customIds = response['custom_ids'];
                this.buildForm(this.activeSEType.type);
                /**
                 * Parse email template by language
                 */
                const languageId = this.patient.language_id;
                this.initTemplate(response['templates'], languageId);

                // Handle active tab for show modal
                let activeQuestionnaire = this.questionnaires[0];
                if (this.questionnaires && this.questionnaires.length > 0 && activeQuestionnaire.id == this.isSendReminder) {

                    if (this.activeSendReminder) {
                        this.changeSEType(this.SETypes[0]); // Send reminder
                    } else {
                        this.changeSEType(this.SETypes[2]); // Open locally
                    }

                    this.form.controls['is_study'].setValue(activeQuestionnaire.is_study);
                    this.form.controls['is_repeated'].setValue(activeQuestionnaire.is_repeated);
                    this.form.controls['custom_id'].setValue(activeQuestionnaire.custom_id);
                    this.showRepeated = activeQuestionnaire.is_repeated;
                }
                if (this.patient.user_patient_id && this.patient.user_patient_id === this.patient.assignee_id) {
                    let reminderType =  this.SETypes[0];
                    this.SETypes = [reminderType];
                    this.changeSEType(reminderType);
                    this.isRegisteredPatient = true;
                }

                this.showModal();
            },
            error => {
                this.errorMessage = this.appService.parseErrors(error);
            }
        );
    }

    sendReminder(model: any, isValid: boolean, url?: string) {
        this.formSubmitted = true;
        if (!isValid) {
            return;
        }
        this.isLoading = true;
        let questionnaireId = this.queryParams['reminder'];

        if (model.due_date instanceof Object) {
            let formattedDueDate = moment({
                day: model.due_date.date.day,
                month: model.due_date.date.month - 1,
                year: model.due_date.date.year,
            });
            model["due_date"] = formattedDueDate.format(this.dateFormat);
        }

        this.questionnairesService.sendReminder(
            this.patientId,
            questionnaireId,
            model.email,
            model.content,
            model.due_date ? model.due_date : this.form.controls.due_date.value,
            model.template_translation_id,
            model.add_disclaimer,
            model.disclaimer_text,
            model.email_subject,
            model.email_header
        ).subscribe(
            response => {
                this.hideModal();
                this.isLoading = false;
            },
            error => {
                this.isLoading = false;
                this.errorMessage = this.appService.parseErrors(error);
            }
        );
    }

    changeTemplate($e) {
        let selectedTemplate;
        if ($e.checked) {
            selectedTemplate = this.repeatedQuestionnaireEmailTemplates[0];
        } else {
            selectedTemplate = this.questionnaireEmailTemplates[0];
        }

        this.form.controls['content'].markAsPristine();
        this.form.controls['content'].setValue(selectedTemplate['content']);
        this.form.controls['email_subject'].setValue(selectedTemplate['email_subject']);
        this.form.controls['email_header'].setValue(selectedTemplate['email_header']);
        this.form.controls['add_disclaimer'].setValue(selectedTemplate['add_disclaimer']);
        this.form.controls['disclaimer_text'].setValue(selectedTemplate['disclaimer_text']);
        this.form.controls['template_translation_id'].setValue(selectedTemplate['id']);
    }
}
